import conseils from '@amo/core/assets/images/AMO_Icons/Conseils-adaptes.svg';
import RecapGPTSection from './RecapGPTSection';
import RecapGPTRow from './RecapGPTRow';

const besoinLabel = (val) => {
    if (val === undefined || val === null) return null;
    return String(val) === '1' ? 'Souhaité' : 'Non souhaité';
};

const fractionnementLabels = {
    'A': 'Annuel',
    'M': 'Mensuel',
};

const RecapGPTBesoins = ({ devoirConseil, police, onEdit }) => (
    <RecapGPTSection title="Recueil du besoin" icon={conseils} onEdit={onEdit}>
        <RecapGPTRow label="Vol / Incendie" value={besoinLabel(devoirConseil?.DevoirVol)} />
        <RecapGPTRow label="Dommages tous accidents" value={besoinLabel(devoirConseil?.DevoirDommage)} />
        <RecapGPTRow label="Assistance / Remorquage" value={besoinLabel(devoirConseil?.DevoirASS2)} />
        <RecapGPTRow label="Protection corporelle" value={besoinLabel(devoirConseil?.DevoirIC)} />
        <RecapGPTRow label="Paiement" value={fractionnementLabels[police?.FractionnementChoisi] || police?.FractionnementChoisi} />
    </RecapGPTSection>
);

export default RecapGPTBesoins;
